import { ENTITY, QueryKey, UserActions } from '@/enums';
import useCheckScopeCombinations from '@/hooks/useCheckScopeCombinations';
import { IRole } from '@/interfaces';
import { AuthService } from '@/services';
import _get from 'lodash/get';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

export const useFetchRoles = () => {
  const { canGetRoles } = useCheckScopeCombinations(
    [[{ entity: ENTITY.ROLE, action: UserActions.GET }]],
    { optimistic: false },
  );

  const { isLoading, data } = useQuery({
    queryKey: [QueryKey.ADMINISTRATOR.ROLE],
    queryFn: AuthService.getRoles,
    meta: { showError: true },
    enabled: canGetRoles,
  });
  const result: IRole[] = useMemo(() => _get(data, 'data', []), [data]);

  return { isLoading, data: result };
};
